export const isSsr = () => {
  return typeof window === 'undefined' || typeof document === 'undefined';
};
